import { render, staticRenderFns } from "./PayPalButton.vue?vue&type=template&id=b27b4bb2"
import script from "./PayPalButton.vue?vue&type=script&lang=js"
export * from "./PayPalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports